/**
 * @Author : ShaJiaJing
 * @Date : 2019/5/30
 * @Version : 1.0
 * @Content : 仪表盘接口配置
 */
import fetch from '@/utils/fetch2'
import $config from '@/config/authAbout/auth.config'
const agreementUrl = $config.userInfoUri + '/consentProtocol'

// 同意使用协议
export function agreement (token) {
  return fetch.post(agreementUrl, { token }, { isForm: true })
}

// 最近执行任务
export function getRecentJobs () {
  return fetch.get('/statistic/jobs')
}

// 机器人与设计器基本信息获取
export function getRobAndTaskBaseInfo () {
  return fetch.get('/statistic/studio/resume')
}

// 机器人与任务执行信息获取
export function getRobAndTaskInfo () {
  return fetch.get('/statistic/robot/resume')
}

// 任务时间趋势
export function getTaskTimeTrends (timeType) {
  return fetch.get('/statistic/jobs/stack', { timeType })
}

// 任务失败趋势
export function getTaskFailTrends (timeType) {
  return fetch.get('/statistic/jobs/fstack', { timeType })
}
